import React from "react";

export type ApprovalStatus = "pending" | "approved" | "rejected";

interface StatusChipProps {
  status: ApprovalStatus;
}

const styles: Record<ApprovalStatus, string> = {
  pending: "bg-warning-100 text-yellow-800",
  approved: "bg-success-100 text-success-800",
  rejected: "bg-error-100 text-error-800",
};

const StatusChip: React.FC<StatusChipProps> = ({ status }) => (
  <span className={`px-2 py-0.5 rounded text-xs font-medium ${styles[status]}`}>
    {status}
  </span>
);

export default StatusChip;
